import { Icon } from '@acme/assets';
import { Separator } from '@acme/foundation';
import { Button, Datepicker, TextInput } from 'flowbite-react';
import { useCallback, useState } from 'react';
import { HiX } from 'react-icons/hi';

interface IExtendRateModalProps {
  onClose: () => void;
  onApprove: (date: Date | null) => void;
}
export const ExtendRateModal = (props: IExtendRateModalProps) => {
  const [selectedDateShow, setSelectedDateShow] = useState<string>('');
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [showPicker, setShowPicker] = useState(false);
  const today = new Date();
  const nextWeek = new Date();
  nextWeek.setDate(today.getDate() + 6);

  const handleDateSelection = (date: Date | null) => {
    if (date) {
      setSelectedDateShow(
        `${date?.getDate()}/${(date?.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`
      );
      setSelectedDate(date);
    }
    setShowPicker(false);
  };

  const handleApprove = useCallback(() => {
    props.onApprove(selectedDate);
  }, [selectedDate]);

  return (
    <div>
      <div className="flex pb-5">
        <h3 className="text-lg font-semibold text-gray-900">
          Продлить действие курса
        </h3>
        <button
          onClick={props.onClose}
          className="text-gray-400 hover:text-gray-600 ml-auto"
        >
          <HiX className="h-3 w-3" />
        </button>
      </div>
      <Separator className="-mx-5" />
      <div className="flex flex-col p-5 gap-4 items-center">
        <div className="text-gray-500 text-base font-normal">
          Максимальное время действия курса: 1 неделя
        </div>
        <div className="relative w-full">
          <TextInput
            icon={() => <Icon name="calendar-month" />}
            className="w-full before:"
            onFocus={() => setShowPicker(true)}
            value={`Курс действителен до: ${selectedDateShow}`}
            readOnly
          ></TextInput>
          {showPicker && (
            <Datepicker
              language="ru"
              weekStart={1}
              value={null}
              minDate={today}
              maxDate={nextWeek}
              onChange={handleDateSelection}
              className="w-full absolute z-10"
              showClearButton={false}
              showTodayButton={false}
              inline
            />
          )}
        </div>
      </div>
      <Separator className="-mx-5" />
      <div className="flex pt-5 gap-4">
        <Button
          color="primary"
          disabled={!selectedDateShow}
          onClick={handleApprove}
        >
          Подтвердить
        </Button>
        <Button color="gray" onClick={props.onClose}>
          Отмена
        </Button>
      </div>
    </div>
  );
};
